"use strict";

var INITIATED = 'INITIATED';
var INITIALIZED = 'INITIALIZED';
var SCAN_IN_PROGRESS = 'SCAN_IN_PROGRESS';
var SCAN_SUCCESS = 'SCAN_SUCCESS';
var SCAN_FAILED = 'SCAN_FAILED';
var ERROR = 'ERROR';
var PROCESSING = 'processing';
var SUCCESS = 'success';
var FAILED = 'failed';
var s3ProxyUploadStatuses = {
  INITIATED: INITIATED,
  INITIALIZED: INITIALIZED,
  SCAN_IN_PROGRESS: SCAN_IN_PROGRESS,
  SCAN_SUCCESS: SCAN_SUCCESS,
  SCAN_FAILED: SCAN_FAILED,
  ERROR: ERROR
};
var TranscodingStatuses = {
  PROCESSING: PROCESSING,
  SUCCESS: SUCCESS,
  FAILED: FAILED
};
module.exports = {
  s3ProxyUploadStatuses: s3ProxyUploadStatuses,
  TranscodingStatuses: TranscodingStatuses
};